import React, { Component, createRef } from "react";
import { isBrowser, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import { Alert, Button, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { FiTrash2, FiVolume2, FiVolumeX } from "react-icons/fi";
import dayjs from "dayjs";
import AvatarAI from "./avatarAI";
import SpeechV2 from "./speechV2";
import ProfileV2 from "../../components/profile/profileV2";
import {
	removeStorageWhenLogout,
	setHtmlStorage,
	statusHtmlStorage,
} from "../../config/helper";
import * as actionHome from "../../store/home/action";
import * as actionAuth from "../../store/auth/action";
import * as actionSending from "../../store/sending/action";
import config from "../../config";
import FetchApi from "../../services/api";
import serviceHome from "../../services/home";
import "./home-v2.css";
import ChatList from "./chatList";

class HomeV2 extends Component {
	constructor(props) {
		super(props);
		this.avatarCache = JSON.parse(localStorage.getItem("dataAvatar"));
		this.muteState = localStorage.getItem("muteState");
		this.elementRef = createRef();
		this.scrollRef = createRef();
		this.state = {
			chatMessage: "",
			sendLoading: false,
			chatLoading: false,
			listChat: [],
			listChatPage: 0,
			swapAvatar: false,
			loadPrev: false,
			blockedApps: {
				state: false,
				message: "",
			},
			activeAvatar: null,
		};
	}

	componentDidMount() {
		if (!statusHtmlStorage("accessToken")) {
			removeStorageWhenLogout();
			window.location.href = "/signin";
		}
		this.getHistoryChat();
		// setInterval(() => {
		//   this.authRefreshToken();
		// }, 30000);
		this.elementRef.current.addEventListener("scroll", this.handleScroll);
		const { id } = this.avatarCache;
		this.setState({ activeAvatar: id });
	}

	componentWillUnmount() {
		this.elementRef.current.removeEventListener(
			"scroll",
			this.handleScroll
		);
	}

	componentDidUpdate() {
		if (!this.state.loadPrev) {
			this.scrollToBottom();
		}
	}

	authRefreshToken = async () => {
		const response = await FetchApi(
			`${config.urls.apiBaseUrl}api/Account/refreshToken`,
			"POST"
		);
		if (response.httpStatus === 200) {
			setHtmlStorage("accessToken", response.data.token);
		}
		if (response.httpStatus === 401) {
			removeStorageWhenLogout();
			window.location.href = "/signin";
		}
	};

	getHistoryChat = async (pageNumber = 0) => {
		const response = await serviceHome.historyChat(pageNumber);

		if (response.httpStatus === 200) {
			const loadedChat =
				response.data?.data?.length > 0 ? response.data?.data : [];

			// let newHistoryChat = [
			// 	{
			// 		answer: localStorage.getItem("AIGreet"),
			// 		createdDate: localStorage.getItem("accessDate"),
			// 		question: "",
			// 	},
			// ];
			// if (loadedChat.length > 0) {
			// 	newHistoryChat = [...loadedChat, ...newHistoryChat];
			// }

			this.setState({
				listChat: loadedChat,
				listChatPage: response.data?.pageNumber,
			});
		}
		if (response.httpStatus === 500) {
			notification.error({
				message: "Something wrong please try again in few minutes.",
			});
		}
	};

	handleSendButton = async (text) => {
		if (text.trim() === "") return;

		this.setState({ sendLoading: true, loadPrev: false });
		const payload = {
			data: JSON.stringify({
				text: text,
				personality: this.props.profile.data.aIpersonality,
				isConversationStart: true,
			}),
		};

		let newChatList = [];
		if (this.state.listChat.length > 0) {
			newChatList = [
				...this.state.listChat,
				{
					answer: null,
					createdDate: new Date().toISOString(),
					question: text,
				},
			];
		}
		this.setState({ listChat: newChatList });

		const sendingTextResponse = await FetchApi(
			`${config.urls.apiBaseUrl}api/GPT/TextChat`,
			"POST",
			payload
		);

		if (sendingTextResponse.httpStatus === 200) {
			this.getHistoryChat();
			this.handleSpeak(sendingTextResponse.data.content);
		}
		if (sendingTextResponse.httpStatus === 500) {
			newChatList[newChatList.length - 1].answer =
				"Oops something wrong, please try again in few minutes.";
			newChatList[newChatList.length - 1].humanExpression = "";
		}
		if (sendingTextResponse.httpStatus === 400) {
			newChatList[newChatList.length - 1].answer =
				"Invalid user input, please send correct input.";
			newChatList[newChatList.length - 1].humanExpression = "";
		}
		if (sendingTextResponse.httpStatus === 401) {
			newChatList[newChatList.length - 1].answer = "Unauthorize.";
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, 3000);
		}
		this.setState({
			listChat: newChatList,
			chatMessage: "",
			sendLoading: false,
		});
	};

	scrollToBottom = () => {
		this.scrollRef.current?.scrollIntoView({ behavior: "smooth" });
	};

	handleSpeak = (text) => {
		if (isMobile || this.muteState === "true") return;

		if ("speechSynthesis" in window) {
			const synthesis = window.speechSynthesis;
			const utterance = new SpeechSynthesisUtterance(text);

			const avatarGender = this.avatarCache.aIsrc
				.replace("/static/media/", "")
				.split(".")[0];

			const voiceGender = synthesis.getVoices().find((voice) => {
				const isFemale = ["woman-1", "woman-2", "woman-3"].includes(
					avatarGender
				);
				return isFemale
					? ["Female", "Victoria", "Aria", "Zira"].some((name) =>
							voice.name.includes(name)
					  )
					: ["Male", "David", "Mark"].some((name) =>
							voice.name.includes(name)
					  );
			});
			utterance.voice = voiceGender;
			setTimeout(() => synthesis.speak(utterance), 1000);
		} else {
			this.setState({
				blockedApps: {
					state: true,
					message:
						"Speech synthesis is not supported in this browser.",
				},
			});
			console.error("Speech synthesis is not supported in this browser.");
		}
	};

	handleScroll = async () => {
		const element = this.elementRef.current;
		if (element.scrollTop === 0) {
			this.setState({ chatLoading: true, loadPrev: true });
			const response = await serviceHome.historyChat(
				this.state.listChatPage + 1
			);
			if (response.httpStatus === 200) {
				const loadedChat =
					response.data?.data?.length > 0 ? response.data?.data : [];

				const newHistoryChat = [...loadedChat, ...this.state.listChat];

				if (loadedChat.length > 0) {
					this.setState({
						listChat: newHistoryChat,
						listChatPage: response.data?.pageNumber,
					});
				}
				this.setState({
					chatLoading: false,
				});
			}
			if (response.httpStatus === 500) {
				notification.error({
					message: "Something wrong please try again in few minutes.",
				});
				this.setState({ chatLoading: false, loadPrev: false });
			}
		}
	};

	muteAvatar = () => {
		if (this.muteState === "true") {
			setHtmlStorage("muteState", "false");
		} else {
			setHtmlStorage("muteState", "true");
		}
		window.location.reload();
	};

	handleDeleteChat = async (avatarID = this.state.activeAvatar) => {
		await this.props.deleteChatByID(avatarID);

		if (this.props.deleteChatResponse.httpStatus === 401) {
			notification.error({ message: "Unauthorize!" });
			removeStorageWhenLogout();
			setTimeout(() => {
				window.location.href = "/signin";
			}, 3000);
		}
		if (this.props.deleteChatResponse.httpStatus === 200) {
			notification.success({ message: "Data has been deleted." });
			setTimeout(() => {
				window.location.reload();
			}, 5000);
		}
		if (this.props.deleteChatResponse.httpStatus === 500) {
			notification.error({
				message: "Something wrong, please try again in few minutes.",
			});
		}
	};

	handleSortChatByDate = (listChat) => {
		let newArrList = [];
		for (let i = 0; i < listChat.length; i++) {
			const chat = listChat[i];
			const createdDate = dayjs(chat.createdDate).format("DD/MM/YYYY");
			const isExist = newArrList.find(
				(item) => item.createdDate === createdDate
			);

			if (!isExist) {
				newArrList.push({ createdDate: createdDate });
			}
		}

		for (let j = 0; j < newArrList.length; j++) {
			const chat = newArrList[j];
			const newArr = [];
			for (let k = 0; k < listChat.length; k++) {
				const element = listChat[k];
				if (
					chat.createdDate ===
					dayjs(element.createdDate).format("DD/MM/YYYY")
				) {
					newArr.push(element);
				}
			}
			newArrList[j].chat = newArr.sort(
				(a, b) => new Date(a.createdDate) - new Date(b.createdDate)
			);
		}

		newArrList = newArrList.sort(
			(a, b) => new Date(a.createdDate) - new Date(b.createdDate)
		);

		return newArrList;
	};

	render() {
		return (
			<Div100vh className="homepage home-v2">
				<div
					className={`home-wrapper${
						this.state.blockedApps.state || isMobile
							? " blocked-apps"
							: ""
					}`}
				>
					<div className="menu-top-section">
						<div className="left-section">
							<ProfileV2
								openSwitchAvatar={this.state.swapAvatar}
								onChangeSwitchAvatar={(value) =>
									this.setState({ swapAvatar: value })
								}
							/>
						</div>
						<div className="right-section">
							<Button
								type="text"
								icon={
									<svg
										width="33"
										height="24"
										viewBox="0 0 33 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<g clipPath="url(#clip0_2065_8976)">
											<path
												d="M24.5 13.5L22.5 11.5L24.5 9.5"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M31.5 8.5V9.5C31.5 10.0304 31.2893 10.5391 30.9142 10.9142C30.5391 11.2893 30.0304 11.5 29.5 11.5L22.5 11.5"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M29.5 2.5L31.5 4.5L29.5 6.5"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M22.5 7.5V6.5C22.5 5.96957 22.7107 5.46086 23.0858 5.08579C23.4609 4.71071 23.9696 4.5 24.5 4.5L31.5 4.5"
												stroke="white"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_2065_8976">
												<rect
													width="12"
													height="14"
													fill="white"
													transform="translate(21 1)"
												/>
											</clipPath>
										</defs>
									</svg>
								}
								onClick={() =>
									this.setState({
										swapAvatar: !this.state.swapAvatar,
									})
								}
							/>
							{isBrowser && (
								<Button
									type="text"
									icon={
										this.muteState === "true" ? (
											<FiVolumeX size={24} />
										) : (
											<FiVolume2 size={24} />
										)
									}
									onClick={() => this.muteAvatar()}
								/>
							)}
							<Button
								type="text"
								icon={<FiTrash2 size={24} />}
								onClick={() => this.handleDeleteChat()}
							/>
						</div>
					</div>
					{isBrowser && this.state.blockedApps.state && (
						<Alert
							message={this.state.blockedApps.message}
							type="error"
						/>
					)}
					<div
						className={`user-conversation${
							this.props.micOpen ? " user-mic-open" : ""
						}`}
					>
						<AvatarAI disabled={true} />
						<div className="user-conversation-wrapper">
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									margin: "0 0 5px",
									width: "100%",
									opacity: this.state.chatLoading ? 1 : 0,
								}}
							>
								<LoadingOutlined />
							</div>
							<div
								ref={this.elementRef}
								style={{
									width: "100%",
									overflow: "overlay",
									paddingRight: 5,
								}}
							>
								{this.handleSortChatByDate(
									this.state.listChat
								).map((chat, key) => {
									return (
										<ChatList
											key={key}
											chat={chat}
											response={this.props.textResponse}
											version="2"
										/>
									);
								})}
								<div
									ref={this.scrollRef}
									style={{ float: "left", clear: "both" }}
								/>
							</div>
						</div>
					</div>
					<SpeechV2
						placeholder="Type your message here..."
						sendLoading={this.state.sendLoading}
						onSend={(text) => this.handleSendButton(text)}
					/>
				</div>
			</Div100vh>
		);
	}
}

const stateToProps = (state) => {
	const { auth, home, profile, sending } = state;
	return {
		loading: home.loading,
		micOpen: home.micOpen,
		historyChat: home.historyChat,
		refreshResponse: auth.refreshResponse,
		sendLoading: sending.loading,
		textResponse: sending.textResponse,
		question: sending.question,
		deleteChatResponse: sending.deleteChatResponse,
		profile: profile.profile,
	};
};

const dispatchToProps = (dispatch) => ({
	authRefresh: () => dispatch(actionAuth.authRefresh()),
	setMicOpen: (payload) => dispatch(actionHome.setMicOpen(payload)),
	getHistoryChat: (pageNumber = "") =>
		dispatch(actionHome.historyChat(pageNumber)),
	sendText: (payload) => dispatch(actionSending.sendText(payload)),
	setSendLoading: (payload) => dispatch(actionSending.setLoading(payload)),
	deleteChatByID: (avatarID) =>
		dispatch(actionSending.deleteChatByID(avatarID)),
});

export default connect(stateToProps, dispatchToProps)(HomeV2);
